import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, AssetDto, AssetReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import AssetInline, { AssetInlineProps } from "./AssetInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity?: AssetDto | AssetReferenceDto | null;
  entityId?: string | null;
  inlineProps?: Partial<AssetInlineProps>;
}

export default function AssetLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.AssetRead]}
      to={ROUTE_PATH.ASSET_VIEW(entityId || entity?.id || "")}
      content={
        <AssetInline entity={entity} entityId={entityId} {...inlineProps} withTooltip={false} />
      }
      {...otherProps}
    />
  );
}
